import React from "react";
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes, rootRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";
import { RootProtected } from "./RootProtected";
//do the same as authProtectedRoutes but with the admin routes & the other roles routes

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected name={route?.name}>
                  {route.useNonAuthLayout ? (
                    <NonAuthLayout>{route.component}</NonAuthLayout>
                  ) : (
                    <VerticalLayout>{route.component}</VerticalLayout>
                  )}
                </AuthProtected>
              }
              key={idx}
              exact={true}
            />
          ))}
          {rootRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <RootProtected>
                  <VerticalLayout>{route.component}</VerticalLayout>
                </RootProtected>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
